import { Heading } from "@components/atoms/Heading"
import { Button } from "@components/atoms/Button"
import { tv } from "@utils/tw"
import { Col, Container, Grid } from "@components/layout/Grid"
import { Card } from "@components/molecules/Cards"
import { EditableText } from "eddev/blocks"
import { DocumentCardFragment } from "../../types.graphql"
import { useIsMobile } from "@hooks/useViewportDerived"

export const DocumentPanel = ({
  documents,
  link,
  headerStyle,
  hideLink,
}: {
  documents: DocumentCardFragment[]
  link: string
  headerStyle?: boolean
  hideLink?: boolean
}) => {
  const isMobile = useIsMobile()

  return (
    <>
      {documents && (
        <>
          <Container className={documentContainerStyles()}>
            <Grid>
              {headerStyle ? (
                <>
                  {!isMobile && !env.admin && <Col initial={12} tablet={1} laptop={2} />}
                  <Col initial={12} tablet={env.admin ? 12 : 10} laptop={env.admin ? 12 : 8}>
                    <div className="flex flex-col items-center gap-5 py-6 w-full [&_span]:type-label-caps [&_span]:text-mid-grey [&_h4]:type-title-s [&_h4]:my-0 [&_h4]:text-center [&_h5]:type-title-xs">
                      <EditableText as="span" store="subtitle" placeholder="Enter subtitle..." />
                      <EditableText as="h4" store="title" placeholder="Enter title..." />
                    </div>
                  </Col>
                </>
              ) : (
                <>
                  <Col initial={8}>
                    <EditableText as="h5" store="title" placeholder="Enter title..." />
                  </Col>
                  <Col initial={4} className="justify-end">
                    <Button color="white" size="small" href={link}>
                      View all
                    </Button>
                  </Col>
                </>
              )}
            </Grid>

            <Grid>
              {headerStyle ? (
                <>
                  {documents.slice(0, 2).map((document, i) => (
                    <Col initial={12} tablet={6} key={i}>
                      <Card type="documentAlt" {...document} />
                    </Col>
                  ))}
                </>
              ) : (
                <>
                  {documents.map((document, i) => (
                    <Col initial={12} tablet={6} key={i}>
                      <Card type="documentAlt" {...document} />
                    </Col>
                  ))}
                </>
              )}
            </Grid>
          </Container>

          {!hideLink && (
            <Container className={browseAllContainerStyles({ light: headerStyle })}>
              <Grid>
                <Col initial={12} tablet={8}>
                  <Heading as="h5">Browse all documents in our library</Heading>
                </Col>
                <Col initial={12} tablet={4}>
                  <Button
                    href="/research-data/library"
                    color={headerStyle ? "white" : "outlineReversed"}
                    size="large"
                    icon={headerStyle ? undefined : "ARROW_RIGHT"}
                    iconStyle={headerStyle ? undefined : "right"}
                  >
                    {headerStyle ? "View All" : "Library"}
                  </Button>
                </Col>
              </Grid>
            </Container>
          )}
        </>
      )}
    </>
  )
}

const documentContainerStyles = tv({
  base: [
    "my-4",
    "[&>.--grid:nth-of-type(1)>div]:flex [&>.--grid:nth-of-type(1)>div]:items-center [&>.--grid:nth-of-type(1)>div]:py-4",
    "[&>.--grid:nth-of-type(2)]:gap-y-5 [&>.--grid:nth-of-type(2)>div]:flex [&>.--grid:nth-of-type(2)>div]:items-stretch",
  ],
})

const browseAllContainerStyles = tv({
  base: [
    "bg-black rounded-md my-7",
    "[&_h5]:text-white [&_h5]:text-center",
    "[&_.--grid>div]:flex [&_.--grid>div]:items-center [&_.--grid>div]:justify-center [&_.--grid>div]:p-5",
    "[&_.--grid>div:nth-of-type(2)]:p-[0_var(--spacing-5)_var(--spacing-5)_var(--spacing-5)]",
    "md:[&_h5]:text-left",
    "md:[&_.--grid>div]:justify-start",
    "md:[&_.--grid>div:nth-of-type(2)]:pt-5 md:[&_.--grid>div:nth-of-type(2)]:justify-end",
  ],
  variants: {
    light: {
      true: "bg-light-grey [&_h5]:text-black",
    },
  },
})
